"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8709],{

/***/ 64149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59106);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_icons_material_KeyboardArrowLeft__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11083);
/* harmony import */ var _mui_icons_material_KeyboardArrowRight__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89703);
/* harmony import */ var _mui_material_ButtonBase__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var tss_react_mui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99109);









var useStyles = (0,tss_react_mui__WEBPACK_IMPORTED_MODULE_2__/* .makeStyles */ .ZL)()({
    fadeScrollButton: {
        color: "rgba(0, 0, 0, .1)"
    },
    scrollButton: {
        width: 56,
        flexShrink: 0
    }
});
var ScrollButton = function(props) {
    var className = props.className, onClick = props.onClick, direction = props.direction, visible = props.visible, disabled = props.disabled, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
        "className",
        "onClick",
        "direction",
        "visible",
        "disabled"
    ]);
    var ref = useStyles(), classes = ref.classes, cx = ref.cx;
    var classNames = disabled ? cx(!visible && classes.fadeScrollButton, classes.scrollButton, className) : cx(classes.scrollButton, className);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_ButtonBase__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        className: classNames,
        onClick: onClick,
        tabIndex: -1,
        disabled: disabled
    }, other), {
        children: direction === "left" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_KeyboardArrowLeft__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            fontSize: "large"
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_KeyboardArrowRight__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            fontSize: "large"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ScrollButton);


/***/ }),

/***/ 60840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59106);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44911);
/* harmony import */ var _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10016);
/* harmony import */ var _mui_material_DialogTitle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34235);
/* harmony import */ var tss_react_mui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99109);








var useStyles = (0,tss_react_mui__WEBPACK_IMPORTED_MODULE_1__/* .makeStyles */ .ZL)()(function(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: "flex",
            alignItems: "center",
            padding: theme.spacing(2),
            backgroundColor: "#f7f7f7"
        },
        /* Styles applied to the action element. */ action: {
            flex: "0 0 auto",
            alignSelf: "center"
        },
        /* Styles applied to the content wrapper element. */ content: {
            flex: "1 1 auto"
        }
    };
});
var DialogHeader = function(_param) {
    var action = _param.action, title = _param.title, onClose = _param.onClose, _children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "action",
        "title",
        "onClose",
        "children"
    ]);
    var classes = useStyles().classes;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_DialogTitle__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                className: classes.content
            }, props), {
                children: title
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classes.action,
                children: [
                    action,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        id: "closeDialog",
                        onClick: onClose,
                        size: "large",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            fontSize: "small"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DialogHeader);


/***/ }),

/***/ 89384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HelpDialogStepper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99758);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44911);
/* harmony import */ var _mui_icons_material_Done__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(75605);
/* harmony import */ var _mui_icons_material_KeyboardArrowLeft__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(11083);
/* harmony import */ var _mui_icons_material_KeyboardArrowRight__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(89703);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14834);
/* harmony import */ var _mui_material_Dialog__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67210);
/* harmony import */ var _mui_material_DialogContent__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98854);
/* harmony import */ var _mui_material_DialogTitle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34235);
/* harmony import */ var _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10016);
/* harmony import */ var _mui_material_MobileStepper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(48028);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2046);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var tss_react_mui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99109);















var useStyles = (0,tss_react_mui__WEBPACK_IMPORTED_MODULE_2__/* .makeStyles */ .ZL)()(function(theme) {
    return {
        root: {
            margin: 0,
            padding: theme.spacing(2)
        },
        closeButton: {
            position: "absolute",
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500]
        },
        rootStepper: {
            flexGrow: 1
        }
    };
});
function HelpDialogStepper(props) {
    var steps = props.steps, title = props.title, open = props.open, onClose = props.onClose;
    var classes = useStyles().classes;
    var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(0), 2), activeStep = ref[0], setActiveStep = ref[1];
    var handleClose = function() {
        onClose();
    };
    var handleNext = function() {
        setActiveStep(function(prevActiveStep) {
            return prevActiveStep + 1;
        });
    };
    var handleBack = function() {
        setActiveStep(function(prevActiveStep) {
            return prevActiveStep - 1;
        });
    };
    var Component = steps[activeStep].component;
    var _title, ref1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Dialog__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        onClose: handleClose,
        "aria-labelledby": "customized-dialog-title",
        open: open,
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_DialogTitle__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                id: "simple-dialog-title",
                children: [
                    (ref1 = (_title = steps[activeStep].title) !== null && _title !== void 0 ? _title : title) !== null && ref1 !== void 0 ? ref1 : "Help",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        "aria-label": "close",
                        className: classes.closeButton,
                        onClick: handleClose,
                        size: "large",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_DialogContent__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_MobileStepper__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                variant: "dots",
                steps: steps.length,
                position: "static",
                activeStep: activeStep,
                className: classes.rootStepper,
                nextButton: activeStep === steps.length - 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    size: "small",
                    onClick: handleClose,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Done__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {}),
                        "Done"
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    size: "small",
                    onClick: handleNext,
                    disabled: activeStep === steps.length - 1,
                    children: [
                        "Next",
                        theme.direction === "rtl" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_KeyboardArrowLeft__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_KeyboardArrowRight__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {})
                    ]
                }),
                backButton: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    size: "small",
                    onClick: handleBack,
                    disabled: activeStep === 0,
                    children: [
                        theme.direction === "rtl" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_KeyboardArrowRight__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_KeyboardArrowLeft__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {}),
                        "Back"
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 29876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37705);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99758);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_icons_material_Undo__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(37496);
/* harmony import */ var _mui_material_Tab__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71077);
/* harmony import */ var _mui_material_Tabs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53006);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94941);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82672);
/* harmony import */ var tss_react_mui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99109);
/* harmony import */ var _components_buttons_scroll_button__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(64149);
/* harmony import */ var _components_pickers_date_time_range_picker__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(63917);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(61431);
/* harmony import */ var _contexts_timepicker__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80484);
/* harmony import */ var _helpers_helper_functions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15608);















var useStyles = (0,tss_react_mui__WEBPACK_IMPORTED_MODULE_2__/* .makeStyles */ .ZL)()(function(theme) {
    var _obj;
    return {
        timeSelector: {
            minWidth: 60,
            maxWidth: 60
        },
        customTimeIcon: {
            height: "16px"
        },
        selectedTimeText: {
            color: "#27aae1"
        },
        timePickerTabs: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            overflow: "hidden",
            "-ms-overflow-style": "none",
            "&::-webkit-scrollbar": {
                width: "0 !important"
            }
        }, theme.breakpoints.down("sm"), {
            marginLeft: theme.spacing(-2),
            marginRight: theme.spacing(-2)
        }),
        tabsScroller: {
            "-ms-overflow-style": "none",
            "&::-webkit-scrollbar": {
                width: "0 !important"
            }
        },
        timePickerSelectedTime: (_obj = {
            marginLeft: "1em"
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, theme.breakpoints.down("sm"), {
            textAlign: "center"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, theme.breakpoints.down("lg"), {
            marginTop: "0.5em"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, theme.breakpoints.up("lg"), {
            marginTop: "1em"
        }), _obj),
        flex: {
            flex: 1,
            overflow: "hidden",
            marginTop: theme.spacing(-1)
        },
        hiddenOnMobile: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, theme.breakpoints.down("sm"), {
            display: "none"
        }),
        hidden: {
            minWidth: 60,
            maxWidth: 60,
            visibility: "hidden"
        }
    };
});
var SelectedText = function(param) {
    var from = param.from, to = param.to;
    var classes = useStyles().classes;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,react_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$)([
        "shared"
    ]), 2), t = ref[0], i18n = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        className: classes.timePickerSelectedTime,
        variant: "body2",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: classes.hiddenOnMobile,
                children: [
                    t([
                        "shared:selected"
                    ], {
                        defaultValue: "Selected"
                    }),
                    ": "
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: classes.selectedTimeText,
                children: (0,_helpers_helper_functions__WEBPACK_IMPORTED_MODULE_7__/* .timeFormatyyyyMMdhmm */ .td)(from, i18n.language)
            }),
            " ",
            t([
                "shared:to"
            ], {
                defaultValue: "to"
            }).toLowerCase(),
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: classes.selectedTimeText,
                children: to ? (0,_helpers_helper_functions__WEBPACK_IMPORTED_MODULE_7__/* .timeFormatyyyyMMdhmm */ .td)(to, i18n.language) : t([
                    "shared:now"
                ], {
                    defaultValue: "now"
                }).toLowerCase()
            })
        ]
    });
};
var TimePicker = function(param) {
    var _hideSelected = param.hideSelected, hideSelected = _hideSelected === void 0 ? false : _hideSelected, includeLargeRanges = param.includeLargeRanges;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_contexts_timepicker__WEBPACK_IMPORTED_MODULE_8__/* .TimepickerContext */ .Ai), from = ref.from, to = ref.to, setTime = ref.setTime, historySize = ref.historySize, undo = ref.undo, relativeTimeInterval = ref.relativeTimeInterval;
    var classes = useStyles().classes;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,react_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$)([
        "shared"
    ]), 1), t = ref1[0];
    var calendarIconRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), open = ref2[0], setOpen = ref2[1];
    var filteredTimeSelectionIntervals = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return _contexts_timepicker__WEBPACK_IMPORTED_MODULE_8__/* .timeSelectionIntervals.filter */ .PZ.filter(function(param) {
            var largeRange = param.largeRange;
            return largeRange === undefined || includeLargeRanges && largeRange === true;
        });
    }, [
        includeLargeRanges
    ]);
    var onTimeSelect = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(_, v) {
        var selectedTimeInterval = filteredTimeSelectionIntervals[Number(v)];
        if (!selectedTimeInterval) {
            return;
        }
        setTime(new Date(Date.now() - selectedTimeInterval.time), null);
    }, [
        setTime,
        filteredTimeSelectionIntervals
    ]);
    var onClickCalendarIcon = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        return setOpen(true);
    }, [
        setOpen
    ]);
    var onClose = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        return setOpen(false);
    }, [
        setOpen
    ]);
    var onCalendarSelect = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(start, end) {
        setTime(start, end);
        onClose();
    }, []);
    var numSelectableTabs = filteredTimeSelectionIntervals.length + 1;
    // relativeTimeInverval is not 100% exact, so +-1 second
    var value = (filteredTimeSelectionIntervals.findIndex(function(param) {
        var time = param.time;
        return relativeTimeInterval && Math.abs(relativeTimeInterval - time) < 1000;
    }) % numSelectableTabs + numSelectableTabs) % numSelectableTabs;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classes.flex,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Tabs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                indicatorColor: "primary",
                className: classes.timePickerTabs,
                classes: {
                    scroller: classes.tabsScroller
                },
                value: value,
                onChange: onTimeSelect,
                variant: "scrollable",
                scrollButtons: true,
                ScrollButtonComponent: _components_buttons_scroll_button__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z,
                allowScrollButtonsMobile: true,
                children: [
                    filteredTimeSelectionIntervals.map(function(param) {
                        var label = param.label;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tab__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            className: classes.timeSelector,
                            label: t([
                                "shared:".concat(label)
                            ], {
                                defaultValue: label
                            })
                        }, label);
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tab__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        className: classes.timeSelector,
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_constants__WEBPACK_IMPORTED_MODULE_12__/* .CALENDAR_PICKER_ICON */ .NR, {
                            className: classes.customTimeIcon
                        }),
                        ref: calendarIconRef,
                        onClick: onClickCalendarIcon
                    }, "custom"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tab__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        className: !!historySize ? classes.timeSelector : classes.hidden,
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Undo__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            className: classes.customTimeIcon
                        }),
                        onClick: undo
                    }, "time-history")
                ]
            }),
            !hideSelected && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SelectedText, {
                from: from,
                to: to
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pickers_date_time_range_picker__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                anchorEl: calendarIconRef.current,
                disableFuture: true,
                from: from,
                to: to || new Date(),
                open: open,
                closePicker: onClose,
                setTime: onCalendarSelect,
                range: true,
                showTabs: true
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TimePicker);


/***/ }),

/***/ 17294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ DeviceContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29901);

var DeviceContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext({
    owner: undefined,
    uuid: "",
    index: "0",
    deviceType: "COUNTER",
    NodePicker: undefined,
    lineNodes: [],
    deviceLineId: undefined
});


/***/ }),

/***/ 89506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ LineContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29901);

var LineContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({
    lineId: undefined,
    lineName: undefined
});


/***/ }),

/***/ 80484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ai": function() { return /* binding */ TimepickerContext; },
/* harmony export */   "PZ": function() { return /* binding */ timeSelectionIntervals; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59106);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99758);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48417);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13515);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29901);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10571);
/* harmony import */ var url__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25998);
/* harmony import */ var url__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(url__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55412);









var timeSelectionIntervals = [
    {
        time: 30..minutes,
        label: "30m"
    },
    {
        time: 60..minutes,
        label: "1h"
    },
    {
        time: 4..hours,
        label: "4h"
    },
    {
        time: 8..hours,
        label: "8h"
    },
    {
        time: 12..hours,
        label: "12h"
    },
    {
        time: 24..hours,
        label: "24h"
    },
    {
        time: 2 * 24..hours,
        label: "48h"
    },
    {
        time: 7 * 24..hours,
        label: "1w"
    },
    {
        time: 30 * 24..hours,
        label: "1m",
        largeRange: true
    }, 
];
var _timeSelectionIntervals = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(timeSelectionIntervals, 3), ref = _timeSelectionIntervals[2], defaultInterval = ref.time;
var TimepickerContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)({
    from: new Date(Date.now() - 8..hours),
    to: null,
    historySize: 0,
    setTime: Function.prototype,
    // FIXME: Undo is currently done /w a simple queue push/pop
    undo: Function.prototype,
    // FIXME: If redo was to be implemented, determine if we want to implement is
    // a tree or a linear history.
    // redo: Function.prototype,
    relativeTimeInterval: null
});
var TimepickerContextWrapper = function(param) {
    var children = param.children;
    var _ref = (0,_hooks__WEBPACK_IMPORTED_MODULE_6__/* .useURLQuery */ .m)(), tmp = _ref.from, queryFrom = tmp === void 0 ? "" : tmp, tmp1 = _ref.to, queryTo = tmp1 === void 0 ? "" : tmp1, restQuery = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_ref, [
        "from",
        "to"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return [
            new Date(queryFrom).getTime() || NaN,
            new Date(queryTo).getTime() || NaN
        ];
    }, [
        queryFrom,
        queryTo
    ]), queryFromMillis = ref[0], queryToMillis = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(queryFromMillis || Date.now() - 8..hours), from = ref1[0], setFrom = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(queryFromMillis < queryToMillis ? queryToMillis : null), to = ref2[0], setTo = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), history = ref3[0], setHistory = ref3[1];
    var relativeTimeInterval = to ? null : Date.now() - from;
    var setTime = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(start, end) {
        // Ensures from and to are updated at the same time. May be removed in future React versions. https://stackoverflow.com/questions/48563650/does-react-keep-the-order-for-state-updates/48610973#48610973
        (0,react_dom__WEBPACK_IMPORTED_MODULE_3__.unstable_batchedUpdates)(function() {
            setFrom(start.getTime());
            setTo(end && start.getTime() < end.getTime() ? end.getTime() : null);
            setHistory((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(history).concat([
                {
                    from: from,
                    to: to
                }
            ]).slice(-10));
        });
    }, [
        history
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        // Ensures from and to are updated at the same time. May be removed in future React versions. https://stackoverflow.com/questions/48563650/does-react-keep-the-order-for-state-updates/48610973#48610973
        (0,react_dom__WEBPACK_IMPORTED_MODULE_3__.unstable_batchedUpdates)(function() {
            if (queryFromMillis && queryFromMillis !== from) {
                setFrom(queryFromMillis);
            }
            if (queryToMillis && queryToMillis !== to) {
                setTo(queryToMillis);
            }
        });
    }, [
        queryFromMillis,
        queryToMillis
    ]);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var newFrom = queryFromMillis !== from;
        var newTo = queryToMillis !== to;
        if (!newFrom && !newTo) {
            return;
        }
        var pathname = router.pathname;
        var url = (0,url__WEBPACK_IMPORTED_MODULE_4__.format)({
            pathname: pathname,
            query: [
                {
                    from: from
                },
                {
                    to: to
                }
            ].reduce(function(query, timestamp) {
                var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(Object.entries(timestamp), 1), ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(ref[0], 2), key = ref1[0], value = ref1[1];
                if (value) {
                    query[key] = new Date(value).toISOString();
                }
                return query;
            }, restQuery)
        });
        router.replace(url, url, {
            shallow: true
        });
    }, [
        from,
        to
    ]);
    var undo = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        if (!history.length) {
            return;
        }
        var cutOff = history.length - 1;
        var ref = [
            history.slice(0, cutOff),
            history.slice(cutOff)
        ], nextHistory = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(ref[1], 1), historyItem = ref1[0];
        // Ensures from and to are updated at the same time. May be removed in future React versions. https://stackoverflow.com/questions/48563650/does-react-keep-the-order-for-state-updates/48610973#48610973
        (0,react_dom__WEBPACK_IMPORTED_MODULE_3__.unstable_batchedUpdates)(function() {
            setHistory(nextHistory);
            if (!historyItem) {
                return;
            }
            setFrom(historyItem.from);
            setTo(historyItem.to);
        });
        return historyItem.from;
    }, [
        history
    ]);
    var futureTimeSpan = Math.max(0, (to || 0) - Date.now());
    var fromDate = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return new Date(from);
    }, [
        from,
        futureTimeSpan
    ]);
    var toDate = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return to ? new Date(to) : null;
    }, [
        to,
        futureTimeSpan
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TimepickerContext.Provider, {
        value: {
            from: fromDate,
            to: toDate,
            setTime: setTime,
            historySize: history.length,
            undo: undo,
            relativeTimeInterval: relativeTimeInterval
        },
        children: children
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (TimepickerContextWrapper);


/***/ }),

/***/ 15608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ millisAsmmss; },
/* harmony export */   "HN": function() { return /* binding */ localDayWithTimezoneOffset; },
/* harmony export */   "KB": function() { return /* binding */ convertPcsPerTimeToWantedUnit; },
/* harmony export */   "MI": function() { return /* binding */ timeFormatVariable; },
/* harmony export */   "Ob": function() { return /* binding */ timeFormatyyyyMMMddhhmmsstimezone; },
/* harmony export */   "Ox": function() { return /* binding */ timeFormatdMMMMhmm; },
/* harmony export */   "Ud": function() { return /* binding */ guardedCallbackString; },
/* harmony export */   "_D": function() { return /* binding */ evaluateWeekSpan; },
/* harmony export */   "_t": function() { return /* binding */ isBrowserLocale24h; },
/* harmony export */   "_v": function() { return /* binding */ sleep; },
/* harmony export */   "j0": function() { return /* binding */ toHHMMSS; },
/* harmony export */   "l8": function() { return /* binding */ DateTimeLabelFormatBasedOnBrowserLocale; },
/* harmony export */   "mc": function() { return /* binding */ xDateFormatBasedOnBrowserLocale; },
/* harmony export */   "rr": function() { return /* binding */ timeFormatyyyyMMdd; },
/* harmony export */   "tI": function() { return /* binding */ timeFormatdMMMMyyyyhhmm; },
/* harmony export */   "td": function() { return /* binding */ timeFormatyyyyMMdhmm; },
/* harmony export */   "vw": function() { return /* binding */ guardedCallback; },
/* harmony export */   "wQ": function() { return /* binding */ mod; },
/* harmony export */   "xQ": function() { return /* binding */ excelReadableDateFormat; },
/* harmony export */   "zs": function() { return /* binding */ timeFormatyyyyMMdhmmss; }
/* harmony export */ });
/* unused harmony exports guardedCallbackNumber, timeFormatyyyyMMMMdhmmss, isNewFeature */
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88149);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99758);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31650);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30489);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22638);
/* harmony import */ var generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25955);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52108);





// TODO: Drop the use of this function, it's too simple to keep :p Excel does
// the formatting for us.
var excelReadableDateFormat = function(date) {
    if (!date) {
        return "";
    }
    return new Date(date);
};
var localDayWithTimezoneOffset = function(date) {
    var localDay = new Date(date.getTime() - date.getTimezoneOffset() * 1..minutes);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(localDay.toISOString().split("T"), 1), calendarDay = ref[0];
    return calendarDay;
};
var guardedCallbackNumber = function(callback) {
    return function(param) {
        var value = param.target.value;
        var parsedValue = Number(value);
        if (Number.isNaN(parsedValue)) {
            return;
        }
        return callback(parsedValue);
    };
};
var guardedCallbackString = function(callback) {
    return function(param) {
        var value = param.target.value;
        if (typeof value !== "string") {
            return;
        }
        return callback(value);
    };
};
var guardedCallback = guardedCallbackString;
var mod = function(n, m) {
    return (n % m + m) % m;
};
/**
 * Time Formatting 7/3/2021 13:00 or 3/7/2021 1:00 PM
 * @param time
 */ var timeFormatyyyyMMdhmm = function(time, locale) {
    var genericTimeFormat = {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric"
    };
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(time, genericTimeFormat, {
        locale: locale
    });
};
function millisAsmmss(ms) {
    var minutes = Math.floor(ms / (60 * 1000));
    var minutesms = ms % (60 * 1000);
    var sec = Math.floor(minutesms / 1000);
    return "".concat(minutes.toLocaleString(undefined, {
        minimumIntegerDigits: 2
    }), ":").concat(sec.toLocaleString(undefined, {
        minimumIntegerDigits: 2
    }));
}
/**
 * Time Formatting 7/3/2021 13:00:00 or 3/7/2021 1:00:00 PM
 * @param time
 */ var timeFormatyyyyMMdhmmss = function(time, locale) {
    var genericTimeFormat = {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
    };
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(time, genericTimeFormat, {
        locale: locale
    });
};
/**
 * Time Formatting 7. marts 13:00 or March 7, 1:00 PM
 * @param time
 */ var timeFormatdMMMMhmm = function(time, locale) {
    var genericTimeFormat = {
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric"
    };
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(time, genericTimeFormat, {
        locale: locale
    });
};
/**
 * Time Formatting 7. marts 2021 13:00 or March 7, 2021, 1:00 PM
 * @param time
 */ var timeFormatdMMMMyyyyhhmm = function(time, locale) {
    var genericTimeFormat = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric"
    };
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(time, genericTimeFormat, {
        locale: locale
    });
};
/**
 * Time Formatting 7/3/2021 or 3/7/2021
 * @param time
 */ var timeFormatyyyyMMdd = function(time, locale) {
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(time, Date) === false || isNaN(time.getTime())) {
        console.error("!Error: Parameter time was not an instane of date!");
        return "Invalid Date!";
    }
    var genericTimeFormat = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    };
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(time, genericTimeFormat, {
        locale: locale
    });
};
/**
 * Time Formatting 7/3/2021 13:00:00 or 3/7/2021 1:00:00 PM
 * @param time
 */ var timeFormatyyyyMMMMdhmmss = function(time, locale) {
    var genericTimeFormat = {
        year: "numeric",
        month: "short",
        weekday: "long",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
    };
    return intlFormat(time, genericTimeFormat, {
        locale: locale
    });
};
/**
 * Time Formatting:
 * Wed, 7. Mar, 2021, 13:00:00 Central European Standard time
 * or
 * Wed, Mar 7, 2021, 1:00:00 PM Central European Standard time
 * @param time
 */ var timeFormatyyyyMMMddhhmmsstimezone = function(time, locale) {
    var genericTimeFormat = {
        year: "numeric",
        month: "short",
        day: "2-digit",
        weekday: "short",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        timeZoneName: "long"
    };
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(time, genericTimeFormat, {
        locale: locale
    });
};
var isBrowserLocale24hCache = {};
/**
 * return true if locale in browser is 24h format
 */ var isBrowserLocale24h = function(language) {
    if (isBrowserLocale24hCache.hasOwnProperty(language)) {
        return isBrowserLocale24hCache[language];
    } else {
        var res = !new Intl.DateTimeFormat(language || navigator.language, {
            hour: "numeric"
        }).format(0).match(/AM|PM/);
        isBrowserLocale24hCache[language] = res;
        return res;
    }
};
/**
 * Time Formatting Monday, 15. Mar, 2021 - 13:00:00.000 or Monday, Mar 15, 2021 - 01:00:00.000 PM
 */ var xDateFormatBasedOnBrowserLocale = function(language) {
    if (isBrowserLocale24h(language)) {
        return "%A, %b %e, %Y - %H:%M:%S.%L";
    }
    return "%A, %e. %b, %Y - %I:%M:%S.%L%p";
};
/**
 * Time Formatting adds AM/PM formatting if browser locale is AM/PM
 */ var DateTimeLabelFormatBasedOnBrowserLocale = function(language) {
    var formats = {};
    if (isBrowserLocale24h(language)) {
        formats = {
            millisecond: "%H:%M:%S.%L",
            second: "%H:%M:%S",
            minute: "%H:%M",
            hour: "%H:%M",
            day: "%e. %b",
            week: "%e. %b",
            month: "%e. %b",
            year: "%b"
        };
    } else {
        formats = {
            millisecond: "%I:%M:%S.%L%p",
            second: "%I:%M:%S%p",
            minute: "%I:%M%p",
            hour: "%I:%M%p",
            day: "%b %e",
            week: "%b %e",
            month: "%b %e",
            year: "%b"
        };
    }
    return formats;
};
/**
 * Note: Format this way, instead of using date-fns, because date-fns format is timezone aware,
 * resulting in format(0, 'HH:mm:ss') = '01:00:00' for GMT+1.
 */ var toHHMMSS = function(v) {
    var secNum = Math.abs(Math.floor(v / 1000));
    var hours = Math.floor(secNum / 3600);
    var minutes = Math.floor((secNum - hours * 3600) / 60);
    var seconds = secNum - hours * 3600 - minutes * 60;
    hours = hours === 0 || isNaN(hours) ? "00" : (hours < 10 ? "0" : "") + "".concat(hours);
    minutes = minutes === 0 || isNaN(minutes) ? "00" : (minutes < 10 ? "0" : "") + "".concat(minutes);
    seconds = seconds === 0 || isNaN(seconds) ? "00" : (seconds < 10 ? "0" : "") + "".concat(seconds);
    var fs = hours + ":" + minutes + ":" + seconds;
    return v < 0 ? "-".concat(fs) : "".concat(fs);
};
/**
 * if i=14 it returns 14:00 or 2:00 PM depending on browser locale
 * @param i
 */ var timeFormatVariable = function(i, language) {
    if (isBrowserLocale24h(language)) {
        return i + ":00";
    } else {
        var timeString = "";
        if (i % 12 !== 0) {
            timeString = (i % 12).toString();
        } else {
            timeString = 12..toString();
        }
        if (i > 11) {
            timeString = timeString + ":00 PM";
        } else {
            timeString = timeString + ":00 AM";
        }
        return timeString;
    }
};
/**
 * turns number of pcs per time into wanted time unit (min/hour/day)
 */ var convertPcsPerTimeToWantedUnit = function(noOfPcs, currentUnit, wantedUnit) {
    var pcsPerMin = 0;
    //Convert pcs/currentUnit into pcs/min
    switch(currentUnit){
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__/* .ChartTimeScale.DAY */ .cW.DAY:
            pcsPerMin = noOfPcs / 60 / 24;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__/* .ChartTimeScale.HOUR */ .cW.HOUR:
            pcsPerMin = noOfPcs / 60;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__/* .ChartTimeScale.MINUTE */ .cW.MINUTE:
            pcsPerMin = noOfPcs;
            break;
        default:
            _types__WEBPACK_IMPORTED_MODULE_4__/* .assertUnreachable */ .U(currentUnit);
            break;
    }
    //Convert pcs/min into pcs/wantedUnit
    var pcsPerWantedUnit = 0;
    switch(wantedUnit){
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__/* .ChartTimeScale.DAY */ .cW.DAY:
            pcsPerWantedUnit = pcsPerMin * 60 * 24;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__/* .ChartTimeScale.HOUR */ .cW.HOUR:
            pcsPerWantedUnit = pcsPerMin * 60;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__/* .ChartTimeScale.MINUTE */ .cW.MINUTE:
            pcsPerWantedUnit = pcsPerMin;
            break;
        default:
            _types__WEBPACK_IMPORTED_MODULE_4__/* .assertUnreachable */ .U(wantedUnit);
            break;
    }
    return pcsPerWantedUnit;
};
var isNewFeature = function(releaseTime) {
    var age = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 7..days;
    return Date.now() <= new Date(releaseTime).getTime() + age;
};
function sleep(milliseconds) {
    return new Promise(function(r) {
        return setTimeout(r, milliseconds);
    });
}
var evaluateWeekSpan = function(date) {
    var dateCopy = new Date(date);
    dateCopy.setHours(0, 0, 0, 0);
    var monday = (0,date_fns__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(dateCopy, 1);
    var mondayNextWeek = (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(monday);
    return [
        monday,
        mondayNextWeek
    ];
};


/***/ })

}]);